import React from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';

const PayPal = () => {
  const clientId =
    'AYPA6GLy8eNCIfz7L0VEOmTPSJrZYM2KfRdU-2IBgMTuUoKLac7huCSn9RKXf6oaiSbgMadacQP3sV2X';

  const initialOptions = {
    clientId,
    currency: 'CAD',
    intent: 'capture',
  };

  const onCreateOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: '1500',
          },
        },
      ],
    });
  };
  const onApproveOrder = (data, actions) => {
    return actions.order.capture().then((details) => {
      const name = details.payer.name.given_name;
      alert(`Transaction completed by ${name}`);
    });
  };

  return (
    <div>
      <h1>PayPal</h1>
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          style={{ layout: 'horizontal' }}
          createOrder={(data, actions) => onCreateOrder(data, actions)}
          onApprove={(data, actions) => onApproveOrder(data, actions)}
        />
      </PayPalScriptProvider>
    </div>
  );
};

export default PayPal;
